module.exports = __webpack_public_path__ + "media/ca_slide27_programa1.65bf9565.mp4";